import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Minus = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 6 6"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path d="M0 2.25L0 3.75 6 3.75 6 2.25z" />
    </svg>
  );
};

Minus.displayName = 'Minus';
